<div class="header">
    <div class="header-title">
        <slot name="icon" class="header-title__icon"></slot>
        <h1 class="header-title__text">
            {{title}}
            <span class="tooltip" (keydown.enter)="fltrInfoTooltip.toggle()" (click)="fltrInfoTooltip.toggle()" *ngIf="tooltipText">
              <i-feather
              #fltrInfoTooltip="matTooltip"
              name="info"
              [matTooltip]="tooltipText"
              matTooltipPosition="below"
              matTooltipClass="custom-mat-tooltip"
              ></i-feather>
          </span>
        </h1>
    </div>

    <div class="header-avatar">
        <slot name="avatar"></slot>
    </div>
</div>
